import React, { useEffect, useState } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  FlatList,
} from "react-native";
import { Feather, MaterialIcons } from "@expo/vector-icons";
import AddAdvert from "./addAdvert";
import Modal from "modal-enhanced-react-native-web";
import { apiservice } from "../service/api";
import { useRecoilValue } from "recoil";
import { tokenState } from "../reducer";
import { useIsFocused } from "@react-navigation/native";
const { width, height } = Dimensions.get("window");

const ManageAdvert = () => {
  const [data1, setdate1] = useState([]);
  const [page, setpage] = useState(0);
  const [modal, setmodal] = useState(false);
  const [state, setState] = useState({});
  const token = useRecoilValue(tokenState);
  const focus = useIsFocused();

  async function getallUniversity() {
    const res = await apiservice({
      path: "/adv/getall",
      method: "get",
    });
    if (res.status == 200) {
      setdate1(res.data);
    }
  }

  useEffect(() => {
    getallUniversity();
  }, [focus, page]);

  return (
    <View style={styles.container}>
      <Modal
        animationType="none"
        transparent={true}
        visible={modal}
        onRequestClose={() => {
          setmodal(!modal);
        }}
      >
        <View
          style={{
            width: width,
            height: height,
            backgroundColor: "#000000bb",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              width: width * 0.5,
              height: height * 0.3,
              backgroundColor: "#fff",
              paddingHorizontal: 20,
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontFamily: "Prompt-Bold",
                color: "#202020",
                alignSelf: "center",
              }}
            >
              ต้องการลบ มหาวิทยาลัย นี้ใช่หรือไหม
            </Text>
            <View
              style={{
                width: width * 0.3,
                flexDirection: "row",
                justifyContent: "space-between",
                alignSelf: "center",
                marginTop: 20,
              }}
            >
              <TouchableOpacity
                onPress={() => setmodal(false)}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ยกเลิก
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={async () => {
                  const res = await apiservice({
                    path: "/adv/delete/" + state.id,
                    method: "delete",
                  });
                  console.log(res);
                  if (res.status == 200) {
                    setState();
                    setmodal(false);
                    getallUniversity();
                  }
                }}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ตกลง
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              width: width * 0.591,
              fontSize: 18,
              fontFamily: "Prompt-Bold",
              color: "#202020",
            }}
          >
            จัดการโฆษณา
          </Text>

          <View
            style={{
              width: width * 0.591,
              height: height * 0.06,
              alignItems: "flex-end",
            }}
          >
            <TouchableOpacity
              onPress={() => setpage(1)}
              style={{
                width: width * 0.041,
                height: height * 0.037,
                backgroundColor: "#43A2D4",
                borderRadius: 5,
              }}
            >
              <Text style={styles.TextButton}>+ เพิ่ม</Text>
            </TouchableOpacity>
          </View>

          <View
            style={{
              width: width * 0.591,
              height: height * 0.6,
              borderWidth: 1,
              overflow: "hidden",
              borderColor: "#C2C2C2",
              borderTopLeftRadius: 5,
              borderTopRightRadius: 5,
              backgroundColor: "#ffff",
            }}
          >
            <View
              style={{
                width: width * 0.591,
                height: height * 0.054,
                backgroundColor: "#002377",
                flexDirection: "row",
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
              }}
            >
              <View
                style={{
                  width: width * 0.076,
                  height: height * 0.054,
                  justifyContent: "center",
                }}
              >
                <Text style={[styles.Textheader, { margin: "auto" }]}>
                  ลำดับ
                </Text>
              </View>
              <View
                style={{
                  width: width * 0.121,
                  height: height * 0.054,
                  justifyContent: "center",
                }}
              >
                <Text style={[styles.Textheader, { margin: "auto" }]}>
                  รูปภาพ
                </Text>
              </View>
              <View
                style={{
                  width: width * 0.156,
                  height: height * 0.054,
                  justifyContent: "center",
                }}
              >
                <Text style={[styles.Textheader, { paddingLeft: 30 }]}>
                  ชื่อ
                </Text>
              </View>
              <View
                style={{
                  width: width * 0.156,
                  height: height * 0.054,
                  justifyContent: "center",
                }}
              >
                <Text style={[styles.Textheader, { paddingLeft: 30 }]}>
                  Link
                </Text>
              </View>
              <View
                style={{
                  width: width * 0.082,
                  height: height * 0.054,
                  justifyContent: "center",
                }}
              >
                <Text style={styles.Textheader}></Text>
              </View>
            </View>

            <FlatList
              data={data1}
              renderItem={({ item, index }) => {
                return (
                  <View
                    style={{
                      width: width * 0.591,
                      height: height * 0.25,
                      flexDirection: "row",
                      backgroundColor: index % 2 == 0 ? "#ffff" : "#E8E8E8",
                    }}
                  >
                    <View
                      style={{ width: width * 0.076, height: height * 0.25 }}
                    >
                      <Text style={[styles.Textdata, { margin: "auto" }]}>
                        {index + 1}
                      </Text>
                    </View>
                    <View
                      style={{ width: width * 0.121, height: height * 0.25 }}
                    >
                      <View
                        style={{
                          width: width * 0.104,
                          height: height * 0.185,
                          borderRadius: 5,
                          borderWidth: 1,
                          overflow: "hidden",
                          borderColor: "#00000050",
                          margin: "auto",
                          backgroundColor: "#ffff",
                        }}
                      >
                        <Image
                          style={{
                            width: width * 0.103,
                            height: height * 0.18,
                            borderRadius: 5,
                          }}
                          source={{ uri: item.image_url }}
                        />
                      </View>
                    </View>
                    <View
                      style={{
                        width: width * 0.156,
                        height: height * 0.25,
                        justifyContent: "center",
                      }}
                    >
                      <Text style={[styles.Textdata, { paddingLeft: 30 }]}>
                        {item.name}
                      </Text>
                    </View>
                    <View
                      style={{
                        width: width * 0.156,
                        height: height * 0.25,
                        justifyContent: "center",
                      }}
                    >
                      <Text style={[styles.Textdata, { paddingLeft: 30 }]}>
                        {item.link}
                      </Text>
                    </View>
                    <View
                      style={{
                        width: width * 0.082,
                        height: height * 0.25,
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <TouchableOpacity
                        onPress={() => {
                          setState(item);
                          setpage(1);
                        }}
                      >
                        <Feather name="edit" size={24} color="black" />
                      </TouchableOpacity>

                      <TouchableOpacity
                        onPress={() => {
                          setState(item);
                          setmodal(true);
                        }}
                      >
                        <MaterialIcons name="delete" size={24} color="black" />
                      </TouchableOpacity>
                    </View>
                  </View>
                );
              }}
            />
          </View>
        </View>
      )}
      {page == 1 && <AddAdvert state={state} page={page} setPages={setpage} />}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Textheader: { fontSize: 20, color: "#ffff", fontFamily: "Prompt-Regular" },
  Textdata: { fontSize: 16, fontFamily: "Prompt-Regular" },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});
export default ManageAdvert;
